<div class="content">
  <div *ngIf="!!arrangedDocs?.length" class="content grid-1-auto">
    <!--ResultView-->
    <div class="content">
      <!--<div  *ngIf="!isLoading" class="host-container" style="height: 100%">-->
      <div *ngIf="isLoading" class="content" style="position: absolute; width: 100%">
        <div class="splash loading"><div class="spinner"><div></div><div></div><div></div><div></div></div></div>
      </div>
      <div  class="host-container" style="height: 100%">
        <div [style.visibility]="isLoading ? 'hidden' : 'visible'" *ngIf="currentResource" style="height: 100%;">
          <div class="pdf-viewer-box" style="height: 1px;">
            <pdf-viewer class="host-pdf-view" style="display: block;"
                        (after-load-complete)="stopLoadingPDF($event)"
                        [src]="currentResource || null"
                        [render-text]="false" [original-size]="true" [fit-to-page]="true"
                        [show-borders]="true"
                        [show-all]="true"></pdf-viewer>
          </div>
        </div>
      </div>
    </div>

    <!-- rechte seite-->
    <div class="content app-border-left width-400 app-layout-report-doc-result" style="padding: 0.65rem;">
      <!--Berichtsname-->
      <div class="md-menu-break" style="margin-bottom: 20px; color: var(--c-text-400)">
        {{selectKey === 'auID' ? 'Auftrag' : 'Vorgang'}} {{vorgOrAuNr}}
      </div>

      <!-- dokumenten einstellungen-->
      <div style="margin-bottom: 24px;">
        <div style="font-size: 16px; font-weight: 600; margin-bottom: 16px; color: var(--c-text); padding-left: 14px">{{getRessource('Document')}}</div>

        <div style="margin-bottom: 16px;">
          <exg-input [caption]="getRessource('Filename')" name="Dateiname"
                     [(ngModel)]="saveModel.dokName" type="text" ></exg-input>
        </div>

        <div style="margin-bottom: 16px; display: flex; gap: 8px; align-items: end;">
          <div style="flex: 1;">
            <exg-select name="template"
                        [caption]="getRessource('template.Header')"
                        [(ngModel)]="selectedTemplateIndex"
                        (ngModelChange)="onTemplateDropdownChange()"
                        [list]="availableTemplates"
                        listdisplay="name">
            </exg-select>
          </div>
          <button class="md-btn"
                  style="height: 32px; min-width: auto; padding: 6px 12px; font-size: 12px;"
                  (click)="showTemplateModal()">
            <i class="fas fa-eye" style="margin-right: 4px;"></i>
          </button>
        </div>

        <div style="margin-bottom: 8px;">
          <exg-checkbox [caption]="getRessource('AddCover')"
                        [(ngModel)]="saveModel.hasCover"
                        class="md-check-reverse">
          </exg-checkbox>
        </div>
      </div>

      <!--Save Location-->
      <div class="content">
        <div style="font-size: 1rem; font-weight: 600; margin-bottom: 1rem; color: var(--c-text); padding-left: 14px">{{getRessource('SaveLocation')}}</div>

        <!-- Auftrag -->
        <div style="margin-bottom: 16px;">
          <exg-input name="auftrag"
                     caption="{{getGlobal('Case')}}"
                     type="text"
                     [(ngModel)]="auftragNr"
                     disabled="true">
          </exg-input>
        </div>

        <!-- Vorgang -->
        <div *ngIf="taskList.length > 0" style="margin-bottom: 0.5rem;">
          <exg-select name="vorgang"
                      caption="{{getGlobal('Task')}}"
                      [(ngModel)]="selectedTaskIndex"
                      [list]="taskList"
                      listdisplay="vorgNr">
          </exg-select>
        </div>
      </div>

      <!--Save Actions-->
      <div style="width: 100%;">
        <div style="font-size: 1rem; font-weight: 600; margin-bottom: 1rem; color: var(--c-text); padding-left: 14px">{{getRessource('saveIn')}}</div>
	      <exg-checkbox [caption]="getGlobal('Case')"
                      class="md-check-reverse"
                      [(ngModel)]="saveToCase">
        </exg-checkbox>
	      <exg-checkbox [caption]="getGlobal('Task')"
                      class="md-check-reverse"
                      *ngIf="taskList.length > 0"
                      [(ngModel)]="saveToTask">
        </exg-checkbox>

        <div class="grid-auto-1">
          <i class="search-filter-action fas fa-download"
             [tooltip]="getRessource('Download')"
             style="margin: .5rem .75rem .25rem;"
             (click)="downloadReportDocPDF()">
          </i>
          <button class="md-btn"
                  style="width: 90%"
                  [disabled]="!saveToCase && !saveToTask"
                  (click)="saveReportDoc()">
            {{getGlobal('Save')}}
          </button>
        </div>
      </div>

    </div>
  </div>

  <ng-container *ngIf="!!!arrangedDocs?.length">
    <div class="content">
      <div class="splash empty">
        <p>{{getRessource('DataGhost')}}</p>
      </div>
    </div>
  </ng-container>
</div>



<!-- template todo: modal? -->
<div [style.display]="showTemplateSelection ? 'flex' : 'none'"
     style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.5); z-index: 1000;align-items: center; justify-content: center;"
     (click)="hideTemplateModal()">

  <div style="background: white; border-radius: 8px; max-width: 90vw; width: 1000px; max-height: 85vh; display: flex; flex-direction: column;"
       (click)="$event.stopPropagation()">

    <div class="app-section-header app-space-bottom_1" style="padding: 1.5rem 1.5rem 0 1.5rem; flex-shrink: 0;">
      <h3 style="margin: 0; font-size: 18px; font-weight: 600;">
        {{getRessource('template.SelectTemplate')}}
      </h3>
    </div>

    <div style="overflow-y: auto; flex: 1; padding: 1.5rem;">
      <div class="content" style="display: flex; flex-direction: column; gap: 30px;">
        <div *ngFor="let folder of templatesByFolder | keyvalue">

          <h4 class="app-list-secondary-text"
              style="margin: 0 0 12px 0; font-weight: 600; border-bottom: 1px solid var(--c-dark-m1); padding-bottom: 8px;">
            {{folder.key}}
          </h4>

          <div style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 16px;">
            <div *ngFor="let template of folder.value"
                 [class.bg-sub-sidebar]="selectedTemplatePreview === template.id"
                 class="app-cursor-pointer"
                 style="border-radius: 8px; padding: 12px; text-align: center;"
                 (click)="selectTemplatePreview(template.id)">

              <div style="width: 100%; height: 250px; background: #f5f5f5; border-radius: 4px; margin-bottom: 8px; overflow: hidden; display: flex; align-items: center; justify-content: center;">
                <img [src]="template.previewUrl"
                     [alt]="template.name + ' preview'"
                     style="width: 100%; height: 100%; object-fit: contain;">
              </div>

              <div class="app-list-secondary-text"
                   style="font-weight: 500; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                {{template.name}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="md-menu-footer"
         style="display: flex; gap: 12px; justify-content: flex-end; padding: 12px 1.5rem 1.5rem 1.5rem; flex-shrink: 0;">
      <button class="md-btn" (click)="hideTemplateModal()">
        {{getGlobal('Cancel')}}
      </button>
      <button class="md-btn-solid" (click)="applyTemplate()">
        {{getGlobal('Apply')}}
      </button>
    </div>
  </div>
</div>
